import { RootState } from '../store';

export const getDefaultCampaigns = (state: RootState) => state.campaign.defaultCampaigns;
export const getBrandCampaigns = (state: RootState) => state.campaign.brandCampaigns;
export const getSelectedCampaign = (state: RootState) => state.campaign.selectedCampaign;
